import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { numberWithCommas } from '../../../utils/consts/index';
class FormatLastNumberColor extends Component {
  render() {
    let { number, mainColor, lastColor } = this.props;

    return (
      <>
        <span className={`text-${mainColor}`}>
          {/* {numberWithCommas((number / 260000).toFixed(2).toString())} */}
          {numberWithCommas((number / 10).toFixed(0).toString())}
        </span>
        {/* <span>,</span> */}
        {/* <span className={`text-${mainColor}`}>
          {Math.ceil(number / 10)
            .toString()
            .substring((number / 10).toString().length - 3)}
        </span> */}
      </>
    );
  }
}
export default injectIntl(FormatLastNumberColor);
